import PasswordRecovery from '@/views/PasswordRecovery.vue';

const passwordRecoveryRoutes = [
  {
    path: '/password-recovery/:token?',
    name: 'password-recovery',
    component: PasswordRecovery,
  },
];

export default passwordRecoveryRoutes;
